/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import {
  POINT,
  POINT_COMPANY_ALLOCATION_DETAILS,
  POINT_COMPANY_DETAILS,
  POINT_PRICING,
} from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: POINT,
    lazy: () => import("./routes/PointOverview"),
  },
  {
    path: POINT_COMPANY_DETAILS,
    lazy: () => import("./routes/PointCompanyDetails"),
  },
  {
    path: POINT_COMPANY_ALLOCATION_DETAILS,
    lazy: () => import("./routes/PointCompanyAllocationDetails"),
  },
  {
    path: POINT_PRICING,
    lazy: () => import("./routes/PointPricing"),
  },
] as RouteObject[];
